export default __webpack_public_path__ + "static/media/ipad_12.4068948e.png";